import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/redux';
import { selectIsAuthenticated, selectUser } from '@/store/redux/slices/authSlice';
import { ROUTES } from '../config';

interface PrivateRouteProps {
  children: ReactNode;
}

/**
 * Route guard for authenticated users only
 * Redirects to login if not authenticated
 */
export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const user = useAppSelector(selectUser);
  const location = useLocation();

  if (!isAuthenticated) {
    console.log('[PrivateRoute] User not authenticated, redirecting to login');
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (user?.mustChangePassword && location.pathname !== ROUTES.CHANGE_PASSWORD) {
    return <Navigate to={ROUTES.CHANGE_PASSWORD} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
